import { useEffect, useState } from "react";
import { Button } from "components/atoms";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import "./index.scss";

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

interface IProps {
  segment: any;
  index?: number;
}

export const ConditionalClassBtns = ({
  segment,
  index,
}: IProps) => {
  const [isClassSegmentBtnEnable, setIsClassSegmentBtnEnable] = useState(false);
  const [isShowViewReportBtn, setIsShowViewReportBtn] = useState(false);

  useEffect(() => {
    const fifteenMinsBeforeTime: any = dayjs
      .utc(segment.StarttimeUTC)
      .local()
      .subtract(15, "m");

    const interval = setInterval(() => {
      if (
        dayjs().isSameOrAfter(fifteenMinsBeforeTime) &&
        dayjs().isSameOrBefore(dayjs.utc(segment.EndtimeUTC).local())
      ) {
        setIsClassSegmentBtnEnable(true);
      } else {
        setIsClassSegmentBtnEnable(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [segment.EndtimeUTC, segment.StarttimeUTC]);

  useEffect(() => {
    const viewReportInterval = setInterval(() => {
      if (
        dayjs().isAfter(dayjs.utc(segment.EndtimeUTC).local()) &&
        segment.RecordingUrl !== "" &&
        segment.RecordingUrl !== null
      ) {
        setIsShowViewReportBtn(true);
      } else {
        setIsShowViewReportBtn(false);
      }
    }, 1000);

    return () => clearInterval(viewReportInterval);
  }, [segment.EndtimeUTC, segment.RecordingUrl]);

  if (isShowViewReportBtn) {
    return (
      <div className="btn-wrapper">
        <Button
          onClick={() => {
            window.open(segment.RecordingUrl, "_blank");
          }}
          label={"View Recording"}
          type="score"
          icon={false}
          btnId={`home-btn-${index}`}
        />
      </div>
    );
  } else {
    if (isClassSegmentBtnEnable) {
      return (
        <div className="btn-wrapper red-btn">
          <Button
            onClick={() => {
              window.open(segment.ClassUrl, "_blank");
            }}
            label={"Launch Class"}
            type="score"
            icon={false}
            btnId={`home-btn-${index}`}
          />
        </div>
      );
    } else {
      return (
        <div className="btn-wrapper class-segment">
          <Button
            label={"Launch Class"}
            type="score"
            icon={false}
            isDisabled={true}
            btnId={`home-btn-${index}`}
          />
        </div>
      );
    }
  }
};
